import React from "react";
import filterTypes from "components/Table/filterTypes";
import BasicCell from "components/Table/components/BasicCell";
import { areaFilterOptions } from "selectors/areas";
import { seasonsOptionsSelector } from "selectors/seasonsSelector";
import DateRangeSelect from "components/Table/components/Filters/DateRangeSelect";
import moment from "moment";
import { employeeOptionsSelector } from "selectors/employee";
import { contractorFilterOptions } from "selectors/generalTasks";
import { varietiesOptionSelector } from "selectors/areas";
import { boxUnitOptionsSelector } from "selectors/boxUnits";
import { Button, Icon, Popup } from "semantic-ui-react";
import style from "../routes/Harvest/PackedBoxes/PackedBoxes.module.css";
import { calcNotAllocatedPallets } from "routes/Harvest/Stock/Stock";
import { Link } from "react-router-dom";

export const getStockTableColumns = (isFetching, navigate, onDelete) => {
  const columnsConfig = {
    variety: {
      withSort: true,
      type: "string",
      id: "variety",
      title: "Variety",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ variety }) => variety.name || "-",
      withSort: true,
      cellWidth: 2,
    },
    boxUnit: {
      withSort: true,
      type: "string",
      id: "boxUnit",
      title: "Box suits",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ boxUnit }) => boxUnit.displayName || "-",
      withSort: true,
      cellWidth: 2,
    },
    unitsPerPallet: {
      withSort: true,
      type: "string",
      id: "unitsPerPallet",
      title: "Units on pallet",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ boxUnit }) => boxUnit.unitsPerPallet || "-",
      withSort: true,
      cellWidth: 2,
    },

    notAllocatedPallets: {
      withSort: true,
      type: "string",
      id: "notAllocatedPallets",
      title: "Not allocated pallets",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: (d) => calcNotAllocatedPallets(d) || "-",
      withSort: true,
      cellWidth: 2,
    },
    packedBoxesCount: {
      withSort: true,
      type: "string",
      id: "packedBoxesCount",
      title: "Units in Stock",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ packedBoxesCount }) => packedBoxesCount || "-",
      withSort: true,
      cellWidth: 2,
    },
    palletsCount: {
      withSort: true,
      type: "string",
      id: "palletsCount",
      title: "Pallets in stock",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ palletsCount }) => palletsCount || "-",
      withSort: true,
      cellWidth: 2,
    },
    cratingPrice: {
      withSort: true,
      type: "string",
      id: "cratingPrice",
      title: "Crating price",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ boxUnit }) => boxUnit.cartingPrice || "-",
      withSort: true,
      cellWidth: 2,
    },
    btnWrapper: {
      withSort: false,
      type: "string",
      id: "btnWrapper",
      title: "",
      cellWidth: 2, // of 16, see Semantic Table
      accessor: ({ id }) => {
        return (
          <div className={style.wrapper}>
            <div className={style.iconWrapper}>
              <Popup
                inverted
                position="bottom center"
                content={"Edit"}
                size="tiny"
                trigger={
                  <div className={style.editButtonWrapper}>
                    <Button
                      as={Link}
                      to={`/harvest/stock/item/${id}`}
                      onClick={(event) => {
                        return (
                          // navigate(``),
                          event.stopPropagation()
                        );
                      }}
                      className={style.editButton}
                      floated="right"
                      icon={<Icon name="edit" />}
                      size="small"
                    />
                  </div>
                }
              />
              <Popup
                inverted
                position="bottom center"
                content={"Delete"}
                size="tiny"
                trigger={
                  <Button
                    onClick={(event) => {
                      return onDelete(id), event.stopPropagation();
                    }}
                    className={style.deleteButton}
                    floated="right"
                    icon={<Icon name="trash alternate" />}
                    size="small"
                  />
                }
              />
            </div>
          </div>
        );
      },
      withSort: true,
      cellWidth: 2,
    },
  };

  return Object.entries(columnsConfig).map(([id, targetColumn]) => ({
    id,
    ...targetColumn,
    accessor: targetColumn.accessor || id,
    Header: targetColumn.title,
    Cell: targetColumn.Cell || BasicCell,
    ...(targetColumn.sortFields ? { sortFields: targetColumn.sortFields } : {}),
    ...(targetColumn.filter ? { filter: targetColumn.filter } : {}),
  }));
};
